import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import LocalNavigationItem from "./LocalNavigationItem";
import { useDocument } from "@hooks/useDocument";
import { useWindow } from "@hooks/useWindow";
import useDebounce from "@hooks/useDebounce";
const LocalNavigationWidget = ({ links }) => {
    const myDocument = useDocument();
    const myWindow = useWindow();
    const navRef = useRef(null);
    const lastSavedScrollValueRef = useRef(0);
    const { debounceFn } = useDebounce({ delay: 100 });
    const localNavFixedClassName = "local-navigation--fixed";
    const headerMenuClassName = "hidden";
    const headerMenuID = "#header";
    const scrollHandler = () => {
        const currentScrollValue = myWindow.pageYOffset || myDocument.documentElement.scrollTop;
        const userScrolledUp = currentScrollValue < lastSavedScrollValueRef.current;
        const userScrolledDown = currentScrollValue > lastSavedScrollValueRef.current;
        const headerMenu = myDocument.querySelector(headerMenuID);
        if (!headerMenu) {
            return;
        }
        const headerMenuHeight = headerMenu === null || headerMenu === void 0 ? void 0 : headerMenu.offsetHeight;
        const localNavInitialPosition = navRef.current.getBoundingClientRect().top;
        const slideUp = () => {
            headerMenu.classList.remove(headerMenuClassName);
            navRef.current.classList.remove(localNavFixedClassName);
        };
        const slideDown = () => {
            headerMenu.classList.add(headerMenuClassName);
            navRef.current.classList.add(localNavFixedClassName);
        };
        const userIsNotAtTheBeginningOfPage = myWindow.innerHeight + myWindow.scrollY + headerMenuHeight >= myDocument.body.offsetHeight;
        if (userScrolledDown && localNavInitialPosition <= headerMenuHeight) {
            slideDown();
        }
        else if (userScrolledUp && !userIsNotAtTheBeginningOfPage) {
            slideUp();
        }
        else if (userScrolledUp && userIsNotAtTheBeginningOfPage && headerMenu.style.display === "none") {
            slideUp();
        }
        lastSavedScrollValueRef.current = Math.max(currentScrollValue, 0);
    };
    const debouncedScrollHandler = debounceFn(scrollHandler);
    useEffect(() => {
        const sub = myWindow && myWindow.addEventListener("scroll", debouncedScrollHandler);
        return () => sub;
    }, [myWindow, navRef, debouncedScrollHandler]);
    return (_jsx("nav", { className: "local-navigation", ref: navRef, children: links && links.length !== 0 && (_jsx("ul", { children: links.map((link) => (_jsx("li", { children: _jsx(LocalNavigationItem, { link: link }) }, link.url + link.title))) })) }));
};
export default LocalNavigationWidget;
